<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-product-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form>
        <div class="row">
          <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10">
              Image du produit
            </label>
            <div class="d-flex align-items-center">
              <img
                v-if="imagepreview"
                :src="imagepreview"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <div>
                <input
                  ref="updateImgInput"
                  type="file"
                  accept="image/*"
                  class="d-none"
                  @change="logoSelected"
                />
                <button
                  type="button"
                  class="btn btn-primary me-2"
                  @click="() => updateImgInput?.click()"
                >
                  Choisir la photo
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="cancelImage"
                >
                  Annuler
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-3">
              <label>Magasin:</label>
              <v-select
                class="custom-select-height"
                label="name"
                v-model="customer"
                :options="clientList"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10"
                >Nom du produit</label
              >
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. Sensung Smart Watch"
                v-model="prod_name"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Référence Produit
              </label>
              <input
                type="text"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. Sensung Smart Watch"
                v-model="ref_prod"
                :disabled="variants == true"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description Produit
              </label>
              <div class="mb-0">
                <textarea
                  v-model="note_prod"
                  placeholder="Write your product description"
                  class="form-control shadow-none rounded-0 text-black"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10"
                >Quantité</label
              >
              <input
                type="number"
                min="1"
                class="form-control shadow-none rounded-0 text-black"
                placeholder="e.g. 120.00"
                v-model="qnty"
                :disabled="variants == true"
              />
            </div>
          </div>
          <hr />
          <div class="col-12 mb-40">
            <input
              class="form-check-input"
              id="toggle1"
              type="checkbox"
              v-model="variants"
              :true-value="true"
              :false-value="false"
            />
            <label class="form-check-label ms-2" for="toggle1">
              Ajouter Variant!
            </label>
          </div>

          <div class="col-12 mb-20" v-if="variants">
            <form @submit.prevent="repeateAgain" class="repeater-form">
              <div
                class="row mb-3"
                v-for="(item, index) in items"
                :key="item.id"
                :id="String(item.id)"
              >
                <!-- Référence -->
                <div class="col-md-4">
                  <div class="mb-2">
                    <label class="form-label">Référence *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.ref"
                      placeholder="#Réf *"
                      required
                    />
                  </div>
                </div>

                <!-- Nom de la variante -->
                <div class="col-md-4">
                  <div class="mb-2">
                    <label class="form-label">Nom de la variante *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.name"
                      placeholder="Nom de la variante *"
                      required
                    />
                  </div>
                </div>

                <!-- Quantité -->
                <div class="col-md-3">
                  <div class="mb-2">
                    <label class="form-label">Quantité *</label>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.qnty"
                      min="1"
                      placeholder="1"
                      required
                    />
                  </div>
                </div>

                <!-- Supprimer -->
                <div class="col-lg-1 col-md-1 d-flex align-items-end">
                  <button
                    type="button"
                    class="btn btn-outline-danger w-100"
                    @click="removeItem(index)"
                    style="margin-bottom: 0.5rem"
                  >
                    <i class="flaticon-delete me-1"></i>
                  </button>
                </div>
              </div>
            </form>

            <!-- Ajouter nouvelle variante -->
            <button
              type="button"
              class="btn btn-outline-info mt-2 d-flex align-items-center"
              @click="repeateAgain"
            >
              <i class="bi bi-plus-circle me-2"></i>
              Nouvelle Variante
            </button>
          </div>

          <div class="col-md-12">
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              @click="addProduct"
              :disabled="loading"
            >
            <div class="spinner-border" role="status" v-if="loading">
    <span class="visually-hidden">Loading...</span>
</div>

              {{ loading ? "En cours..." : "Enregistrer" }}
              
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "AddProduct",
  components: {},
  setup: () => {
    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const clientList = ref([]);
    const loading = ref(false);

    const { showToast } = useAppToast();

    const variants = ref(false);
    const items = ref([{ id: Date.now(), ref: "", name: "", qnty: 1 }]);
    const customer = ref<{ id?: number; name?: string }>({});
    const prod_name = ref("");
    const ref_prod = ref("");
    const note_prod = ref("");
    const qnty = ref(1);
    const image = ref<File | null>(null);

    onMounted(async () => {
      try {
        const res = await api.get(`/api/auth/CstmrsInv`);
        clientList.value = res.data;
      } catch (error) {
        console.error("Error fetching clients:", error);
        clientList.value = [];
      }
    });
    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        image.value = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const repeateAgain = () => {
      items.value.push({
        id: Date.now() + Math.random(),
        ref: "",
        name: "",
        qnty: 1,
      });
    };

    const removeItem = (index) => {
      items.value.splice(index, 1);
    };

    async function addProduct() {
      if (Object.keys(customer.value).length === 0) {
        showToast("Merci de choisir un client", "error");
        return;
      }
    const data = new FormData();
      data.append("cstmr_id", customer.value.id !== undefined ? String(customer.value.id) : "");
      data.append("cstmr_name", customer.value.name ?? "");
      data.append("prod_name", prod_name.value ?? "");
      data.append("image", image.value ?? "");
      data.append("prod_desc", note_prod.value ?? "");
      data.append("ref_prod", ref_prod.value ?? "");
      data.append("list", JSON.stringify(items.value));
      data.append("variants", variants.value ? "1" : "0");
      data.append("qnty", String(qnty.value ?? 1));
      console.log(data);

      loading.value = true;
        const res = await api.post(`/api/auth/addProduct`,data, {headers: { "Content-Type": "multipart/form-data" }});
        loading.value = false;

        if (res.data.message == "success") {
          // reset fields
          prod_name.value = "";
          ref_prod.value = "";
          note_prod.value = "";
          qnty.value = 1;
          image.value = null;
          items.value = [{ id: Date.now(), ref: "", name: "", qnty: 1 }];
          variants.value = false;
          customer.value = {};

          showToast("Ajouté avec succès", "success");
        } else if (res.data.message == "exist") {
          showToast(
            "Ce référence " + res.data.ref + " est déjà existante",
            "error"
          );
        }
    }

    return {
      updateImgInput,
      imagepreview,
      logoSelected,
      cancelImage,
      clientList,
      variants,

      repeateAgain,
      removeItem,
      items,
      addProduct,

      loading,
      customer,
      ref_prod,
      prod_name,
      note_prod,
      qnty,
      image,
    };
  },
});
</script>